"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.originWhitelist = void 0;
exports.originWhitelist = [/http:\/\/localhost.*/, /https:\/\/www-t\.storebrand\.no\/kjop-forsikring.*/];
